import { render } from "./ThreeDCharacter.vue?vue&type=template&id=520f1efa&scoped=true"
import script from "./ThreeDCharacter.vue?vue&type=script&lang=js"
export * from "./ThreeDCharacter.vue?vue&type=script&lang=js"

import "./ThreeDCharacter.vue?vue&type=style&index=0&id=520f1efa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520f1efa"]])

export default __exports__